import WebsiteServiceModel            from '@/models/WebsiteServiceModel';
import doc                            from '@widesk-core/decorators/doc';

export default class LinkTypeModel extends WebsiteServiceModel {
	private declare _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'reference': Website_LinkTypeReference;
		'search': string;
	};

	private declare _tsSorts: {
		id: string;
		reference: string;
		name: string;
		createdAt: string;
		updatedAt: string;
	};

	static get path(): string {
		return 'link_types/{?id}';
	}

	@doc.string declare reference: string;
	@doc.string declare name: string;
}
